/* Native Shopify links remain usable without JavaScript. */
(function () {
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a.santa-product-button');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var handle = link.getAttribute('data-product-handle');
    if (!handle) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var path = root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle);
    event.preventDefault();
    window.location.assign(path);
  }, false);
})();
